import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  views: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createNewView: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  updateView: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteView: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  searchValue: "",
  selectedPage: 0,
  isTouched: false,
};

export const viewsReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_VIEWS:
      return {
        ...newState,
        views: { ...newState.views, isLoading: true, hasError: false },
      };
    case actionTypes.GET_VIEWS_SUCCESS:
      return {
        ...newState,
        views: { data: action.payload, isLoading: false, hasError: false },
      };
      case actionTypes.SELECTED_VIEW_PAGE:
        return{
          ...newState,
          selectedPage: action.payload
        }  
    case actionTypes.GET_VIEWS_FAILURE:
      return {
        ...newState,
        views: { data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.CREATE_NEW_VIEW:
      return {
        ...newState,
        createNewView: { ...newState.createNewModel, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_NEW_VIEW_SUCCESS:
      return {
        ...newState,
        createNewView: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_NEW_VIEW_FAILURE:
      return {
        ...newState,
        createNewView: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.UPDATE_VIEW:
      return {
        ...newState,
        updateView: { ...newState.updateView, isLoading: true, hasError: false },
      };
    case actionTypes.UPDATE_VIEW_SUCCESS:
      return {
        ...newState,
        updateView: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.UPDATE_VIEW_FAILURE:
      return {
        ...newState,
        updateView: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.DELETE_VIEW:
        return {
          ...newState,
          deleteView: { ...newState.deleteView, isLoading: true, hasError: false },
        };
      case actionTypes.DELETE_VIEW_SUCCESS:
        return {
          ...newState,
          deleteView: { data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.DELETE_VIEW_FAILURE:
        return {
          ...newState,
          deleteView: { data: action.payload, isLoading: false, hasError: true },
        };

    default:
      return { ...newState };
  }
};
